// Hooks (@tanstack/react-query) imports
import { useMutation } from "@tanstack/react-query";

// Configs imports
import api from "../../app/api";

// Custom types imports
import { ApiErrorResponse } from "apisauce";
import { USER_STATUS } from "./types";

interface paramsType {
  email: string;
  status: USER_STATUS;
  notificationID: string | number;
}

export function useChangeStatusUserMutation(
  onSuccessMutation?: (data: any, variables: paramsType) => void,
  onErrorMutation?: (err: ApiErrorResponse<any>, variables: paramsType) => void
) {
  async function changeStatusUser(params: paramsType): Promise<any> {
    const response = await api.post<any>(
      `admin/changestatus/${params.email}/${params.status}`
    );

    if (!response.ok) {
      throw response;
    }

    return response.data;
  }

  return useMutation({
    mutationFn: changeStatusUser,
    onSuccess: onSuccessMutation,
    onError: onErrorMutation,
  });
}
